// @flow
/* eslint-disable no-useless-escape */
const numberWithCommas = (val: number) => {
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export default numberWithCommas;
